import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ChartsService } from '../../../../services/chartService/charts.service';
import { MultiBarChartSpecification } from '../../../../dataModels/data-models';

declare var AmCharts;

@Component({
    moduleId: module.id,
    selector: 'multiple-bar-chart',
    templateUrl: 'multipleBarChart.component.html',
    styleUrls: ['multipleBarChart.component.css']
})

export class MultipleBarChart implements OnInit {
    @Input() chartSpecification: MultiBarChartSpecification;
    drawIt: boolean = false;

    constructor(private chartsService: ChartsService) { }

    ngOnInit() {
        setTimeout(() => {
            this.chartsService.notifyMe.subscribe(() => this.drawChart());
            this.drawChart();
        }, 0);
    }

    drawChart() {
        let chartData = this.chartsService.groupByThenSumEachValOfProperty(this.chartSpecification.data,
            this.chartSpecification.yAxis, this.chartSpecification.xAxis, this.chartSpecification.value,
            this.chartSpecification.perProperty);

        let keys = this.chartsService.getValuesOfProperty(this.chartSpecification.data, this.chartSpecification.xAxis);

        chartData = this.chartsService.getMaxOfSum(chartData, keys, this.chartSpecification.barCount);

        this.drawIt = chartData.length > 0 ? true : false;

        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "type": "serial",
                "theme": "none",
                "categoryField": "key",
                "legend": {
                    "useGraphSettings": true
                },
                "rotate": true,
                "startDuration": 1,
                "titles": [
                    {
                        "text": this.chartSpecification.title,
                        "size": 15
                    }
                ],
                "categoryAxis": {
                    "gridPosition": "start",
                    "position": "left"
                },
                "trendLines": [],
                "graphs": this.getGraphs(keys),
                "guides": [],
                "valueAxes": [
                    {
                        "id": "ValueAxis-1",
                        "position": "bottom",
                        "axisAlpha": 0
                    }
                ],
                "allLabels": [],
                "balloon": {},
                "dataProvider": chartData,
                "export": {
                    "enabled": true
                }

            });
        }, 20);
    }

    getGraphs(keys: string[]) {
        let graphs = [];

        for (let i = 0; i < keys.length; i++) {
            graphs.push({
                "balloonText": keys[i] + ":[[value]]",
                "fillAlphas": 0.8,
                "id": "AmGraph-" + (i + 1),
                "lineAlpha": 0.2,
                "title": keys[i],
                "type": "column",
                "valueField": keys[i]
            });
        }

        return graphs;
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/barCharts/multipleBarChart/MultipleBarChart.component.ts